import { IconProps } from '@/types';
import React from 'react';

export const PaperAirplane = ({
  color = '#3971C0',
  height = '17',
  width = '18',
}: IconProps) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8.5L1.5 1L17.3333 8.5M4 8.5L1.5 16L17.3333 8.5M4 8.5H17.3333"
        stroke={color}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
